import { PntStationStatusItemDto } from '@mi-front/core';
import { Chip, ChipProps, MrtTable } from '@mi-front/ui';
import { Info as InfoIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { ReportResultProps } from '../../../../../../core/reports/types';
import { DetailModal } from './DetailModal';
import { ScheduleStatusMentionsReport } from './ScheduleStatusPntView';

import { FormattedMessage } from 'react-intl';
export function ScheduleStatusMentionsResult(p: ReportResultProps<ScheduleStatusMentionsReport>) {
  const { $t } = useIntl();
  const [detail, showDetail] = useState<PntStationStatusItemDto | null>(null);

  return (
    <>
      <MrtTable
        data={p.result.results}
        columns={[
          {
            header: $t({
              id: 'audit.props.customId',
              defaultMessage: 'Custom ID',
            }),
            accessorKey: 'customId',
            size: 150,
          },
          {
            header: $t({
              id: 'common.name',
              defaultMessage: 'Nombre',
            }),
            accessorKey: 'schedule.name',
            size: 200,
          },
          {
            header: $t({
              id: 'audit.scheduleStatusPntScreen.status',
              defaultMessage: 'Estado',
            }),
            size: 350,
            id: 'status',
            Cell: ({ row: { original: item } }) => {
              const matchesCount = item.matches.length;
              const scheduledCount = item.schedule.count;

              let chipType: ChipProps['type'];

              if (matchesCount === 0) {
                chipType = 'light';
              } else if (matchesCount >= scheduledCount) {
                chipType = 'success';
              } else {
                chipType = 'yellow';
              }

              return (
                <Chip type={chipType}>
                  {matchesCount} / {scheduledCount}
                </Chip>
              );
            },
          },
          {
            header: $t({
              id: 'common.text.actions',
              defaultMessage: 'Acciones',
            }),
            id: 'actions',
            size: 150,
            Cell: ({ row }) => (
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => showDetail(row.original)}
                startIcon={<InfoIcon />}
                sx={{ marginRight: 1 }}
              >
                <FormattedMessage id="common.detailBtn" defaultMessage="Ver detalle" />
              </Button>
            ),
          },
        ]}
      />
      <DetailModal item={detail} onHide={() => showDetail(null)} date={p.values.date} />
    </>
  );
}
